import { Component, OnInit } from '@angular/core';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { DatePipe, Location } from '@angular/common';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { ActivatedRoute, Router } from '@angular/router';
import { SolicitudExService } from '../datosbasicos/datosbasicosEx.service';
import { EnumIdsTwTcTipoClonacion, EnumCodigosTwTcAcciones, EnumIdsTcSeccionSeguimiento } from '../../../_importacion/solicitudes/types/enum';
import { EnumIdsTcEstadoSolicitudEx, EnumIdsTwTcSubTipoSolicitudEx } from '../types/enum';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { Tc } from '../../../core/_infrastructure/types/common';
import { SolicitudSeguimientoExViewModel, TComentarioInspectorExViewModel } from './seguimientoEx.types';
import { SeguimientoExService } from './seguimientoEx.service';

@Component({
    selector: 'app-seguimientoex-edit',
    templateUrl: './seguimientoEx-edit.component.html',
})
export class SeguimientoExEditComponent extends ComponentBase implements OnInit {
    editMode: boolean;
    editTitle = 'Nuevo';

    seguimientoEx: TComentarioInspectorExViewModel;
    solicitudSeguimientoEx: SolicitudSeguimientoExViewModel;
    cols: any[];

    IdEstadoSolicitudEx: number;
    tituloTipoSolicitudEx: string;
    EstadoSolicitudExDescripcion: string;
    CodigoSolicitud: string;
    CodigoTipoSolicitud: string;
    IdResultadoEnvioMuestrasLaboratorioEx: number | null;
    DescripcionIdResultadoEnvioMuestrasLaboratorioEx: string;
    IdSubTipoSolicitudEx: number | null;
    IdSubTipoSolicitudExDescripcion: string;
    IdEstadoCertificadoFitoEx: number;
    IdEstadoCertificadoFitoExDescripcion: string;

    tercerPaisConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_TERCER_PAIS_CON_ATEST_FITO;
    reExpConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_REEXPORTACION_CON_ATEST_FITO;
    canariasConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_CANARIAS_CON_ATEST_FITO;

    public habilitarGuardar = true;
    visibilitySpinner = false;
    esClonada = false;
    vieneDeInspecciones: boolean | undefined = false;
    listSeccion: Tc[];
    listMotivo: Tc[];

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        public datepipe: DatePipe,
        private fb: UntypedFormBuilder,
        private navMenuService: NavMenuService,
        private solicitudExService: SolicitudExService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private seguimientoExService: SeguimientoExService,
        private globalService: GlobalService,
        private _location: Location,
    ) {
        super(authService, notificationService, exceptionHandler);

        this.seguimientoEx = new TComentarioInspectorExViewModel();
    }

    ngOnInit() {
        this.globalService.getAllSeccionSeguimiento().subscribe(res => {
            this.listSeccion = res;
        });
        this.globalService.getAllMotivoSeguimiento().subscribe(res => {
            this.listMotivo = res;
        });

        this.createForm();

        let idSolicitudEx = this.activatedRoute.snapshot.params['id'];
        let id = this.activatedRoute.snapshot.params['idSeguimiento'];
        this.vieneDeInspecciones = this.activatedRoute.snapshot.routeConfig?.path!.includes('inspecciones');

        this.guardRefreshPage(idSolicitudEx);

        if (this.vieneDeInspecciones) {
            this.form.patchValue({
                IdSeccion: EnumIdsTcSeccionSeguimiento.ID_INSPECCIONES, //Inspecciones
            });
        }

        //EDICION
        if (id) {
            this.editTitle = 'Editar';
            this.editMode = true;
            this.seguimientoExService.getSeguimientoEx(id).subscribe(result => {
                this.seguimientoEx = result;

                this.CodigoSolicitud = this.seguimientoEx.CodigoSolicitud;
                this.CodigoTipoSolicitud = this.seguimientoEx.CodigoTipoSolicitud;
                this.IdEstadoSolicitudEx = this.seguimientoEx.IdEstadoSolicitudEx;
                this.tituloTipoSolicitudEx = this.seguimientoEx.IdTipoSolicitudExDescripcion;
                this.IdResultadoEnvioMuestrasLaboratorioEx = this.seguimientoEx.IdResultadoEnvioMuestrasLaboratorioEx;
                this.DescripcionIdResultadoEnvioMuestrasLaboratorioEx = this.seguimientoEx.DescripcionIdResultadoEnvioMuestrasLaboratorioEx;
                this.IdSubTipoSolicitudEx = this.seguimientoEx.IdSubTipoSolicitudEx;
                this.IdSubTipoSolicitudExDescripcion = this.seguimientoEx.IdSubTipoSolicitudExDescripcion;
                this.IdEstadoCertificadoFitoEx = this.seguimientoEx.IdEstadoCertificadoFitoEx;
                this.IdEstadoCertificadoFitoExDescripcion = this.seguimientoEx.IdEstadoCertificadoFitoExDescripcion;
                this.esClonada =
                    this.seguimientoEx.TwSolicitudJerarquiaEx != null &&
                    this.seguimientoEx.TwSolicitudJerarquiaEx.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                        ? true
                        : false;

                //SI ES PREVIA
                if (this.seguimientoEx.EsPrevia) {
                    if (
                        this.seguimientoEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA &&
                        this.seguimientoEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_PENDIENTE
                    ) {
                        this.tituloTipoSolicitudEx += '-Previa';
                    }
                }
                this.EstadoSolicitudExDescripcion = this.seguimientoEx.IdEstadoSolicitudExDescripcion;

                this.habilitarGuardar =
                    this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_SEGUIMIENTO_EXPORTACION, this.seguimientoEx.IdEstadoSolicitudEx).Editable &&
                    this.loggedInUser!.Id == this.seguimientoEx.IdInspector;

                if (!this.habilitarGuardar) {
                    this.form.controls['txtObservaciones'].disable();
                    this.form.controls['IdSeccion'].disable();
                    this.form.controls['IdMotivo'].disable();
                    this.form.controls['VisibleSolicitante'].disable();
                }

                this.updateForm();
            });
        }
        //ALTA
        else {
            this.seguimientoExService.getSeguimientosEx(idSolicitudEx).subscribe(result => {
                this.solicitudSeguimientoEx = result;

                this.CodigoSolicitud = this.solicitudSeguimientoEx.CodigoSolicitud;
                this.CodigoTipoSolicitud = this.solicitudSeguimientoEx.CodigoTipoSolicitud;
                this.IdEstadoSolicitudEx = this.solicitudSeguimientoEx.IdEstadoSolicitudEx;
                this.tituloTipoSolicitudEx = this.solicitudSeguimientoEx.IdTipoSolicitudExDescripcion;
                this.IdResultadoEnvioMuestrasLaboratorioEx = this.solicitudSeguimientoEx.IdResultadoEnvioMuestrasLaboratorioEx;
                this.DescripcionIdResultadoEnvioMuestrasLaboratorioEx = this.solicitudSeguimientoEx.DescripcionIdResultadoEnvioMuestrasLaboratorioEx;
                this.IdSubTipoSolicitudEx = this.solicitudSeguimientoEx.IdSubTipoSolicitudEx;
                this.IdSubTipoSolicitudExDescripcion = this.solicitudSeguimientoEx.IdSubTipoSolicitudExDescripcion;
                this.IdEstadoCertificadoFitoEx = this.solicitudSeguimientoEx.IdEstadoCertificadoFitoEx;
                this.IdEstadoCertificadoFitoExDescripcion = this.solicitudSeguimientoEx.IdEstadoCertificadoFitoExDescripcion;
                this.esClonada =
                    this.solicitudSeguimientoEx.TwSolicitudJerarquiaEx != null &&
                    this.solicitudSeguimientoEx.TwSolicitudJerarquiaEx.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                        ? true
                        : false;

                //SI ES PREVIA
                if (this.solicitudSeguimientoEx.EsPrevia) {
                    if (
                        this.solicitudSeguimientoEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA &&
                        this.solicitudSeguimientoEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_PENDIENTE
                    ) {
                        this.tituloTipoSolicitudEx += '-Previa';
                    }
                }
                this.EstadoSolicitudExDescripcion = this.solicitudSeguimientoEx.IdEstadoSolicitudExDescripcion;

                this.habilitarGuardar = this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.MENU_SEGUIMIENTO_EXPORTACION,
                    this.solicitudSeguimientoEx.IdEstadoSolicitudEx,
                ).Editable;

                this.loading = false;
            });
        }
    }

    createForm() {
        this.form = this.fb.group({
            Inspector: [null],
            Fecha: [null],
            IdSeccion: [null, Validators.required],
            IdMotivo: [null, Validators.required],
            VisibleSolicitante: [true],
            txtObservaciones: ['', Validators.required],
        });
    }

    updateForm() {
        this.form.setValue({
            Inspector: this.seguimientoEx.Inspector,
            Fecha: this.datepipe.transform(this.seguimientoEx.Fecha, 'dd/MM/yyyy'),
            IdSeccion: this.seguimientoEx.IdSeccion,
            IdMotivo: this.seguimientoEx.IdMotivo,
            VisibleSolicitante: this.seguimientoEx.VisibleSolicitante,
            txtObservaciones: this.seguimientoEx.Observaciones,
        });
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudExportacion.Id) || this.navMenuService.currentSolicitudExportacion.Id !== id) {
            this.solicitudExService.getSolicitudEx(id).subscribe(result => {
                this.navMenuService.currentSolicitudExportacion = result;
            });
        }
    }

    onBack() {
        //RDLF: se puede navegar también desde el apartado de inspecciones
        this._location.back();
    }

    onCleanObservacion() {
        this.form.setValue({ txtObservaciones: '' });
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos');
            return;
        }

        let seguimientoEx = new TComentarioInspectorExViewModel();

        seguimientoEx.Fecha = new Date();
        seguimientoEx.IdInspector = this.loggedInUser!.Id;
        seguimientoEx.Observaciones = this.form.value.txtObservaciones;
        seguimientoEx.IdSeccion = this.form.value.IdSeccion;
        seguimientoEx.IdMotivo = this.form.value.IdMotivo;
        seguimientoEx.VisibleSolicitante = this.form.value.VisibleSolicitante;

        seguimientoEx.IdSolicitudEx = this.navMenuService.currentSolicitudExportacion.Id;

        seguimientoEx.Id = this.seguimientoEx.Id;

        if (this.editMode) {
            this.seguimientoExService.editSeguimientoEx(seguimientoEx).subscribe({
                next: () => {
                    this.addSuccessMessage('Seguimiento modificado correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        } else {
            this.seguimientoExService.createSeguimientoEx(seguimientoEx).subscribe({
                next: () => {
                    this.addSuccessMessage('Seguimiento añadido correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        }
    }
}
